/**
 * Phase 23 / Plan 23-05 / D-06 — Active-State-Predicate für Mollie-Polling.
 *
 * Mollie-Status-Vokabular: "open" / "pending" / "authorized" / "paid" /
 * "failed" / "expired" / "canceled" (1 l, niemals "cancelled" — Pitfall 9 /
 * Mollie wire value).
 *
 * Aktive Stati (lt. D-06):
 *   - open       — Link versendet, Kunde noch nicht im Checkout
 *   - pending    — Banküberweisung läuft / Pre-Auth in Bearbeitung
 *   - authorized — Klarna et al.: Reservation aktiv, noch nicht erfasst
 *
 * Polling läuft nur bei diesen Stati (30s), stoppt bei allen finalen
 * Zuständen (paid/failed/expired/canceled).
 *
 * Analog `OpenPaymentsList.tsx:152-157` — dort sind nur `open` und `pending`
 * aktiv; Plan 23-05 erweitert um `authorized` (D-06).
 */
export const MOLLIE_ACTIVE_STATUSES: ReadonlyArray<string> = ["open", "pending", "authorized"];

export function isActiveState(status: string | undefined | null): boolean {
    if (!status) {
        return false;
    }
    return MOLLIE_ACTIVE_STATUSES.indexOf(status) !== -1;
}
